import { ApplicationError } from '../application-error';

export class UnknownAuthenticationError extends ApplicationError {
  public override readonly name: string;

  constructor(message: string) {
    super(message);
    this.name = 'UnknownAuthenticationError';
  }
}
